import { render, staticRenderFns } from "./StartPrint.vue?vue&type=template&id=f2f38a72&scoped=true"
import script from "./StartPrint.vue?vue&type=script&lang=js"
export * from "./StartPrint.vue?vue&type=script&lang=js"
import style0 from "./StartPrint.vue?vue&type=style&index=0&id=f2f38a72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f38a72",
  null
  
)

export default component.exports